module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ts-tag",
    class: [_vm.type ? 'ts-tag--' + _vm.type : '', _vm.shape ? 'ts-tag--' + _vm.shape : ''],
    style: ({
      backgroundColor: _vm.bgColor,
      color: _vm.color
    })
  }, [_c('div', {
    class: {
      'ts-tag-text': !!_vm.closable
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('i', {
    staticClass: "ts-tag-close",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("×")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-69ffc67e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsTag.vue
// module id = 838
// module chunks = 39